"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicesFilters = exports.InvoiceLinesView = void 0;
const InvoiceLinesView_yaml_component_1 = __importDefault(require("./InvoiceLinesView.yaml?component"));
exports.InvoiceLinesView = InvoiceLinesView_yaml_component_1.default;
const InvoicesFilters_yaml_component_1 = __importDefault(require("./InvoicesFilters.yaml?component"));
exports.InvoicesFilters = InvoicesFilters_yaml_component_1.default;
